<template>
    <div v-if="backdrop">
        <div
            class="modal fade"
            :class="modal.open ? 'show' : ''"
            style="display: block"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
            @click="$event.target.classList.contains('modal') ? close() : true"
        >
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"> Filter Surat Konfirmasi Piutang</h5>
                        <button type="button" class="close" @click="close()" v-html="loading ? spin() : ic('close')"/>
                    </div>
                    <div class="modal-body default">
                        <div class="row">
                            <div class="col-12 form-group">
                                <label class="form-label" for="perusahaan">Perusahaan</label>
                                <selectize
                                    id="perusahaan"
                                    :settings="selectizeConfig"
                                    data-placeholder="Pilih Perusahaan"
                                    v-model="filter.ids_perusahaan"
                                    :disabled="loading"
                                    @input="_geDepoByPerusahaan($event)"
                                >
                                    <option
                                        :value="perusahaan.id"
                                        v-for="(perusahaan, index) in form.perusahaans"
                                        :key="index"
                                    >
                                        {{ perusahaan.nama_perusahaan }}
                                    </option>
                                </selectize>
                            </div>
                            <div class="col-12 form-group">
                                <label class="form-label" for="depo">Depo</label>
                                <selectize
                                    id="depo"
                                    data-placeholder="Pilih Depo"
                                    :settings="selectizeConfig"
                                    v-model="filter.ids_depo"
                                    :disabled="loading"
                                >
                                    <option
                                        :value="depo.id"
                                        v-for="(depo, index) in form.depos"
                                        :key="index"
                                    >
                                        {{ depo.nama_depo}} - {{ depo.perusahaan.kode_perusahaan }}
                                    </option>
                                </selectize>
                            </div>
                            <div class="col-6 form-group">
                                <label for="tanggal-mulai" class="form-label">Mulai Tanggal Surat</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    required
                                    v-model="filter.start_date"
                                    :max="filter.end_date"
                                    id="tanggal-mulai"
                                />
                            </div>
                            <div class="col-6 form-group">
                                <label for="tanggal-selesai" class="form-label">Sampai Tanggal Surat</label>
                                <input
                                    required
                                    type="date"
                                    class="form-control"
                                    id="tanggal-selesai"
                                    v-model="filter.end_date"
                                    :min="filter.start_date"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-white"
                            @click="close"
                            v-html="'Tutup'">
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            :disabled="loading"
                            @click="submit"
                            v-html="'OK'">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapActions, mapState } from "vuex";

const now = new Date();
export default {
    name: "FormGeneratePenagihan",
    props:{
        isOpen: false
    },
    data(){
        return {
            selectizeConfig: {
                maxItems: 99,
                plugins: ["remove_button"],
            },
            loading: false,
            backdrop: false,
            modal: {
                open: false, 
            },
            form:{
                perusahaans: [],
                depos: [],
                tokos: [],
            },
            filter:{
                ids_perusahaan: [],
                ids_depo: [],
                start_date: new Date(now.getFullYear(), now.getMonth() - 1, 2).toISOString().slice(0, 10),
                end_date: this.dateTime("ymd"),
            }
        }
    },
    mixins: [helper],
    computed:{
        ...mapState('surat_tagihan', {
            detail_surat_tagihans: state => state.datas.detail,
        }),
    },
    methods: {
        ...mapActions("perusahaan", ["getListPerusahaanByAccess"]),
        ...mapActions("surat_tagihan", ["detailGenerateSuratTagihan"]),
        ...mapActions('toko', ['getListToko']),
        ...mapActions("depo", ["getListDepo"]),

        async _getPerusahaan(){
            try {
                this.loading = true
                this.form.perusahaans = await this.getListPerusahaanByAccess()
            } catch (error) {
                console.log(error)
            } finally{
                this.loading = false
            }
        },
        
        async _geDepoByPerusahaan(id_perusahaan){
            try {
                this.loading = true
                this.form.depos = await this.getListDepo({id_perusahaan: id_perusahaan})
            } catch (error) {
                console.log(error)
            }finally{
                this.loading = false
            }
        },  
        submit() {
            this.$emit("submit", this.filter);
            this.close();
        },

        close() {
            this.$emit("update:isOpen", false);
        },
    },
    watch: {
        "isOpen": function(isOpen){
            if (isOpen) {
                this.backdrop = isOpen;
                setTimeout(() => {
                    if(this.form.perusahaans.length <= 0) this._getPerusahaan()
                    this.modal.open = isOpen;
                }, 100);
            } else {
                this.modal.open = isOpen;
                setTimeout(() => {
                    this.backdrop = isOpen;
                }, 100);
            }
        }
    }


}
</script>